import { createContext, useContext } from 'react';

export interface NavPanelControls {
  /** Collapse or expand the app shell's nav panel (the sidebar / dock). */
  toggle: () => void;
}

/**
 * Lets page content drive the shell's nav panel. Needed by the sessions dock
 * (`navStyle: 'sessions'`): the agent stream's sidebar-toggle button must
 * collapse the dock, which lives in the shell, not the page. Kept in its own
 * module so pages don't import the whole `Layout` shell for one callback.
 */
export const NavPanelContext = createContext<NavPanelControls | null>(null);

export function useNavPanel(): NavPanelControls | null {
  return useContext(NavPanelContext);
}
